// extracted by mini-css-extract-plugin
module.exports = {"container":"VoOi3hKhHRLiG9S0e_kkh","subcontainer":"_1C8aX34dXrPjMR5hW7svOM","title":"_8r42zRFhqpMik5XKWXF-p","flex":"zFMh1cwU0ygEhVzjeAORx","content":"_3qzszrzLlAW_IQ6-YChElC"};